import api from "./api";

const SupportCaseAPI = {
    getCaseDetails: (params) => api.get(`/support-cases/user/support-case-details?${params}`),
    getPendingCase: () => api.get(`/support-cases/pending-case`),
    getChattingCase: () => api.get(`/support-cases/chatting-case`),
    getCaseChatBySession: (caseSessionId) => api.get(`/support-cases/case-chat/session/${caseSessionId}`),
    insert: (params) => api.post(`/support-cases/insert`, params),
    accept: (id) => api.post(`/support-cases/accept/${id}`),
    getCurrentSupporter: () => api.get(`/support-cases/current-supporter`),
    reject: (params) => api.post(`/support-cases/reject`, params),
    insertCaseFile: (params) => api.post(`/support-cases/case-files/insert`, params),
    resolved: (id) => api.put(`/support-cases/resolved/${id}`),
    getCaseFileByCaseSession: (params) => api.get(`/support-cases/case-files/case-session?${params}`),
};

export default SupportCaseAPI;